import Router from "@services/router"
import LandingPage from "./components/pages/Landing"
import PrivacyPage from "./components/pages/Privacy"
import SalonPage from "./components/pages/Salon"
import SalonAcceptancesPage from "./components/pages/SalonAcceptances"
import SalonAwardsPage from "./components/pages/SalonAwards"
import SalonConditionsPage from "./components/pages/SalonConditions"
import SalonGalleryPage from "./components/pages/SalonGallery"
import SalonStatusPage from "./components/pages/SalonStatus"
import SupportPage from "./components/pages/Support"
import SalonAcceptancesGalleryPage from './components/pages/SalonAcceptancesGallery'

export default [
    Router.page({ name: "general:landing", path: "/", component: LandingPage }),
    Router.page({ name: "general:privacy", path: "/privacy", component: PrivacyPage }),
    Router.page({ name: "general:support", path: "/support", component: SupportPage }),
    Router.page({ name: "general:salon", path: "/:slug", component: SalonPage }),
    Router.page({ name: "general:salon:gallery", path: "/:slug/gallery", component: SalonGalleryPage }),
    Router.page({ name: "general:salon:acceptances", path: "/:slug/acceptances", component: SalonAcceptancesPage }),
    Router.page({ name: "general:salon:acceptances:gallery", path: "/:slug/acceptances/gallery/:sectionId?", component: SalonAcceptancesGalleryPage }),
    Router.page({ name: "general:salon:awards", path: "/:slug/awards", component: SalonAwardsPage }),
    Router.page({ name: "general:salon:status", path: "/:slug/status", component: SalonStatusPage }),
    Router.page({ name: "general:salon:conditions", path: "/:slug/conditions", component: SalonConditionsPage }),
]